import React from 'react';
import '../../styles/styles.css';
import HlsPlayer from "../../components/hlsplayer";


export default function pandarpur() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Panduranga.jpg" alt="Vittal" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Date in Pandarpur<br />
    Ekadashi Every Month<br />    
    <br />

  </strong></p>
  <p>Official Pandarpur Temple Website : <a href="http://www.vitthalrukminimandir.org/" target="_blank" rel="noopener noreferrer">
  Vittal Mandir Website
</a>
</p>
 </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>God of Pandharpur is worshipped and lovingly called by his devotees with many names in different course of the time, like Pandharinath, Pandurang, Pandhariraya, Vithai, Vithoba, Vithumauli, Vitthal gururao, Pandurang, Hari etc. Vitthal is benevolent for the downtrodden and is bhaktakamkalpadrum and yogiyadurlabh. The sculpture is self made up of sand stone. He has cap just like crown on his head. It is known as shivlinga as it looks like the shivlinga. Face of Shri Vitthal is long, cheeks are bulky, his eyes are looking horizontally straight. He wear’s Makar kundale in his ear. A Kaustubhmni is there around his neck like necklace. Shinke are on his back and on his shrivatsalanchhan. Angads are there on his both arms and on his both wrists he has Manibandhs. dya Shankaracharya wrote a Pandurangashtak, in which he describes Vitthal as “Nitamba Karabhyam Druto Yena Tasmat”. Shri Vitthal put his both hands on his waist. In his right hand he has a Kambal and in left hand he has Shankha. On his chest, there is a spot where Bhrugurishi had put his feet. There is Vastra around his waist. Soga of Vastra is up to his feet. On his left leg, there is sign of touch of a daasi. Thus this sculpture is standing on a brick.</p>
            </div>
        </div>

 <div className="row mt-3">
                        <div className="col-12">
                          <div className="Desc-box3">
                            <h2 className="live-header">Darshan Live Streaming</h2>
                            <div className="hls-container">
                              <HlsPlayer url="https://cdn1.itekrfid.com/hls/local/index.m3u8"
                              fallbackImage="/images/Panduranga.jpg"   />
                            </div>
                          </div>
                        </div>
        
            </div>



        

    </div>
  )
}

